import { ThemeProvider } from '@emotion/react'
import { CssBaseline } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { StoryContext, StoryFn } from '@storybook/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import jaLocale from 'date-fns/locale/ja'
import { SnackbarProvider } from 'notistack'

import { PresidentCardDefaultTheme, UpsiderDefaultTheme } from '@src/libs'
import { isPresident } from '@src/utils'

export const FreshQueryClientProvider = (
  Story: StoryFn,
  context: StoryContext
) => {
  // Create a new QueryClient for each story to ensure a fresh state
  const queryClient = new QueryClient()
  return (
    <SnackbarProvider hideIconVariant>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider
          theme={
            isPresident() ? PresidentCardDefaultTheme : UpsiderDefaultTheme
          }
        >
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={jaLocale}
            dateFormats={{ monthAndYear: 'yyyy年MM月' }}
          >
            <CssBaseline />
            <Story {...context} />
          </LocalizationProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </SnackbarProvider>
  )
}
